export enum ASSISTENZSYSTEME {
  NICHT_VORHANDEN = 'nichtVorhanden',
  SERIENMAESSIG = 'serienmaessig',
  NACHGERUESTET = 'nachgeruestet',
}

export enum FAHRERKREIS_TYP {
  OFFEN = 'offen',
  FESTGELEGT = 'festgelegt',
  NUR_VN = 'nurVn',
}

export enum VERSICHERUNGSART {
  VERSICHERER_TARIF_WECHSEL = 'versichererTarifWechsel',
  NEUES_FAHRZEUG = 'neuesFahrzeug',
  VOLL = 'Vollversicherung',
  ZUSATZ = 'Zusatzversicherung',
}

export enum CONTRIBUTION_RELIEF_TYPE {
  ABSOLUTE = 'ABSOLUTE',
  PERCENT = 'PERCENT',
}

export enum KASKOTYP {
  HAFTPFLICHT = 'haftpflicht',
  TEILKASKO = 'teilkasko',
  VOLLKASKO = 'vollkasko',
}

export const isKaskoTyp = (obj: unknown): obj is KASKOTYP =>
  Object.values(KASKOTYP).includes(obj as KASKOTYP);
